
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";

import { LuUserPlus } from "react-icons/lu"
import SaveIcon from "@mui/icons-material/Save";
import { TfiCheckBox } from "react-icons/tfi";
import blankprofile from "../../Images/blankprofile.png";


import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Users = ({ pageLables, branchSystemUsers, setBranchSystemUsers, setCurrentUserIndex, systemCd, branchCode, branchemployees, setBranchemployees, usersAreasMode, setUsersAreasMode, setAdminUser, setUserPreveleges, setUserGroupsPreveleges, jobTitles, setJobTitles, userTypes, setUserTypes, systemTypemode }) => {

    const [employeIndex, setEmployeIndex] = useState(null);
    const [employeeDetails, setEmployeeDetails] = useState();    
    const [updating, setUpdating] = useState([]);
    const [employExist, setEmployExist] = useState(false);
    const [logInNameExist, setLogInNameExist] = useState(false);
    
    useEffect(() => {
    }, []);

    function select_user(index) {
        setCurrentUserIndex(index)
        get_user_prevelegs(index)
    }

    const set_employee_mode = () => {
        setEmployExist(false)
        setUsersAreasMode("Edit employee")
    };

    const set_clear_mode = () => {
         setUsersAreasMode("List system user")
    };

    function set_icon(employee_image_name, user_image_name,) {
        if (user_image_name) {
            return <img src={"https://files.amanrow.com/user/" + user_image_name} alt=" " className="user_profile_image" />
        } else
            if (employee_image_name) {
                return <img src={employee_image_name} alt=" " className="user_profile_image" />
            } else {
                return <img src={blankprofile} className="user_profile_image" alt="" />
            }      
    }

    // Read ----------------------   
    const get_user_prevelegs = async (index) => {
        setAdminUser({})
        setUserPreveleges([])
        setUserGroupsPreveleges([])
        try {
            let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));

            const data = {
                info: {
                    lang: userDataLocal.lang,
                    company: userDataLocal.company_cd,
                    user_cd: userDataLocal.user_cd,
                },
                input: {
                    actioncode: "get_user_authintication",
                    system_cd: systemCd,
                    prevelege_user_cd: branchSystemUsers[index].user_cd
                },
            };

            console.log("get_user_prevelegsl input ", data)
            return
            let res = await axios.post(
                `${process.env.REACT_APP_BACK_END_URL}/api/auth/get_user_authintication`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${userDataLocal.token}`,
                    }
                }
            );

            console.log("get_user_prevelegsl output", res);
            
            if (res.data.output.admin_user) { setAdminUser(res.data.output.admin_user) }           
            if (res.data.output.user_preveleges) { setUserPreveleges(res.data.output.user_preveleges) }
            if (res.data.output.user_groups_preveleges) { setUserGroupsPreveleges(res.data.output.user_groups_preveleges) }
            
        } catch (err) {
            console.log(err);
            alert("error message" + err.message);
        }
    };

    const get_employees = async () => {
        setUsersAreasMode("List branch employees") 
        setCurrentUserIndex(null)
        if (branchemployees && branchemployees.length > 0) { alert("will exit");  return }
        try {
            let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));

            const data = {
                info: {
                    lang: userDataLocal.lang,
                    company: userDataLocal.company_cd,
                    user_cd: userDataLocal.user_cd,
                },
                input: {
                    actioncode: "get_branch_employees",
                    system_cd:systemCd,
                    branch_cd: branchCode
                },
            };

            console.log("get_employees input ", data)
            let res = await axios.post(
                `${process.env.REACT_APP_BACK_END_URL}/api/auth/get_branch_employees`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${userDataLocal.token}`,
                    }
                }
            );
            console.log("get_employees output", res);
            if (res.data.output.branch_employees && res.data.output.branch_employees.length > 0) { setBranchemployees(res.data.output.branch_employees) }
            if (res.data.output.job_titles && res.data.output.job_titles.length > 0) { setJobTitles(res.data.output.job_titles) } 
            if (res.data.output.user_types && res.data.output.user_types.length > 0) { setUserTypes(res.data.output.user_types) }  
            
        } catch (err) {
            console.log(err);
            alert("error message" + err.message);
        }
    };
   
    const validate_login_name = async () => {
              
        try {
            let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));

            const data = {
                info: {
                    lang: userDataLocal.lang,
                    company: userDataLocal.company_cd,
                    user_cd: userDataLocal.user_cd,
                },
                input: {
                    actioncode: "validate_login_name",
                    login_name: employeeDetails.login_name                   
                },
            };

            console.log("validate_login_name input ", data)
            
            let res = await axios.post(
                `${process.env.REACT_APP_BACK_END_URL}/api/auth/validate_login_name`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${userDataLocal.token}`,
                    }
                }
            );
            console.log("validate_login_name output", res);
           
            if (
                res.data.output.user_cd) {
                setLogInNameExist(true)
            } else {
                setLogInNameExist(false)
            }

        } catch (err) {
            console.log(err);
            alert("error message" + err.message);
        }
    };

    // Update ----------------------  
    const insert_employee = async (emp_code) => {
        validate_login_name()
        try {
            let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));
            console.log(employeeDetails)
            const data = {
                info: {
                    lang: userDataLocal.lang,
                    company: userDataLocal.company_cd,
                    user_cd: userDataLocal.user_cd,
                },
                input: {
                    actioncode: "insert_employee",
                    update_branch_cd: branchCode,
                    emp_cd: emp_code,
                    system_cd: systemCd,
                    first_name: employeeDetails.first_name,
                    middle_name: employeeDetails.middle_name,
                    last_name: employeeDetails.last_name,
                    email: employeeDetails.email_address,
                    job_cd: employeeDetails.job_cd,
                    login_name: employeeDetails.login_name,
                    passowrd_id: employeeDetails.passowrd_id,
                    user_type_cd: employeeDetails.user_type_cd 
                },
            };

            console.log("insert_employee input ", data)
            
            let res = await axios.post(
                `${process.env.REACT_APP_BACK_END_URL}/api/auth/insert_employee`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${userDataLocal.token}`,
                    }
                }
            );

            console.log("insert_employee output", res);
            if (res.data.output.barnch_system_users && res.data.output.barnch_system_users.length > 0) {
                setBranchSystemUsers(res.data.output.barnch_system_users)
            } else {
                setBranchSystemUsers([])
            }           
            if (res.data.output.emp_users && res.data.output.emp_users.length > 0) {
                setBranchemployees(res.data.output.barnch_system_users)
            } else {
                setBranchemployees([])
            }
            setUsersAreasMode("List branch employees")
           
        } catch (err) {
            console.log(err);
            alert("error message" + err.message);
        }
    };

    const add_user = (update_user_cd, update_emp_cd, update_function, employee_index) => {
        alert("index = " + employee_index + " , user_cd = " + update_user_cd + " , emp_cd = " + update_emp_cd)
        setEmployeIndex(employee_index)
        if (update_user_cd) {
            setUsersAreasMode("Edit user")
        } else {
            setEmployeeDetails({})
            setEmployExist(true)
            setUsersAreasMode("Edit employee") 
            
        }

        //if (systemCd === "Lcc") {
           
        //}
        //update_system_users(update_user_cd, 2, "add")
    };

    const update_system_users = async (update_user_cd, user_type_cd , update_function) => {
        setUpdating([update_user_cd, ...updating])
        try {
            let userDataLocal = JSON.parse(localStorage.getItem("amanrowuserData"));
            const data = {
                info: {
                    lang: userDataLocal.lang,
                    company: userDataLocal.company_cd,
                    user_cd: userDataLocal.user_cd,
                },
                input: {
                    actioncode: "update_system_user",
                    update_branch_cd: branchCode,
                    system_cd: systemCd,
                    user_type_cd: user_type_cd,
                    update_user_cd: update_user_cd,
                    update_function: update_function
                },
            };
            console.log("update_system_users input ", data);
           
            let res = await axios.post(
                `${process.env.REACT_APP_BACK_END_URL}/api/auth/update_system_user`,

                data,
                {
                    headers: {
                        Authorization: `Bearer ${userDataLocal.token}`,
                    }
                }
            );

            console.log("update_system_users output ", res);

            if (res.data.output.branch_users.length > 0) {    
                setBranchSystemUsers(res.data.output.branch_users);
            }
            const newArray = updating.filter(item => item !== res.data.output.update_user_cd);
            setUpdating(newArray);

        } catch (err) {
            console.log(err);
            alert("error message" + err.message);
        }
    };

    return <>
        <div style={{ height: "calc(100vh - 86px)", overflow: "auto", overflowX: "hidden" }} >
            {/*Buttons bar*/}
            <div style={{ height: "36px" }}>
                <div className="normal_float normal_text_align ">
                    {usersAreasMode !== "List system user" && (
                        <>
                            <Tooltip title="Back" placement="bottom" arrow>
                                <IconButton onClick={() => { set_clear_mode() }}><ArrowBackIcon color="inherit" fontSize="small" /></IconButton>
                            </Tooltip>
                        </>
                    )}
                </div>
                <div className="opposite_float opposite_text_align">
                    {usersAreasMode === "List system user" && (
                        <>
                            <Tooltip title={pageLables && pageLables[2].description} placement="bottom" arrow>
                                <IconButton onClick={() => { get_employees() }}>
                                    <ModeOutlinedIcon color="inherit" fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </>)} 
                    {usersAreasMode === "List branch employees" && (
                        <>
                            <Tooltip title={pageLables && pageLables[4].description} placement="bottom" arrow>
                                <IconButton>
                                    <IconButton onClick={() => set_employee_mode()}><LuUserPlus color="inherit" fontSize="18px" /></IconButton>
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                    {usersAreasMode === "Edit employee" && (
                        <>
                            <Tooltip title="add New" placement="bottom" arrow>
                                <IconButton onClick={() => { insert_employee(null) }}>
                                    <IconButton><SaveIcon color="inherit" fontSize="small" /></IconButton>
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                </div>
                <div style={{ clear: "both" }}></div>
            </div>

            {(usersAreasMode === "List system user" || usersAreasMode === "List branch employees") && (
                <>
                    <div style={{marginTop: "6px" }}>
                        {/*users area*/}          
                        {branchSystemUsers.length > 0 && branchCode && branchSystemUsers.map((system_users, index) => {
                            if (system_users.branch_no === branchCode)
                                return (
                                    <div className="user_line" onClick={() => { if (usersAreasMode === "List system user") {select_user(index)}}}>
                                    <div key={branchSystemUsers.user_cd + index} className="user_line_area">
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                {updating.length > 0 && updating.find((update_user_cd) => update_user_cd === system_users.user_cd) ?
                                                    <div className="icon_tree_area" style={{width:"26px"}}><span className='loader-spiner'></span></div>
                                                    :
                                                    <div className="icon_tree_area" style={{ width: "26px" }} onClick={() => { update_system_users(system_users.user_cd, 0, "remove") }}>
                                                        {usersAreasMode === "List branch employees" && (<TfiCheckBox size="16" />)}
                                                    </div>
                                                }

                                            {/*<div style={{ width: "26px", display: "flex", alignItems: "center" }} onClick={() => { update_system_users(system_users.user_cd, 0, "remove") }}>{usersAreasMode === "List branch employees" && (<TbCheckbox size="22" />)}</div>*/}
                                                <div>
                                                    {set_icon(null, system_users.image_name)}
                                               </div>
                                            <div className="space-betw-vertical" style={{ margin: "0px 10px" }}>
                                                <div> {system_users.full_name}</div>
                                                <div>{system_users.job_title}{system_users.user_type && <span style={{ color: "gray" }}>  |  {system_users.user_type}  </span>}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        )}
                    </div>
                </>
            )}           
            {usersAreasMode === "List branch employees" && (
                <>
                    <div style={{marginTop: "20px" }}>                    
                        {branchemployees.length > 0 && branchemployees.map((branch_employees, index) => (
                            <div className="user_line">
                                {branchSystemUsers.find((user) => user.user_cd === branch_employees.user_cd) ?
                                   <div></div>
                                    :
                                    <div key={branch_employees.user_cd + index} className="user_line_area">
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                {updating.length > 0 && updating.find((update_user_cd) => update_user_cd === branch_employees.user_cd) ?
                                                    <div className="icon_tree_area" style={{width:"26px"}}><span className='loader-spiner'></span></div>
                                                    :
                                                <div className="icon_tree_area" style={{ width: "26px" }} onClick={() => { add_user(branch_employees.user_cd, branch_employees.emp_cd, "insert", index); }}>
                                                        {usersAreasMode === "List branch employees" && (<div className="unchecked_checkbox" style={{width:"15px", height:"15px"}} ></div>)}
                                                    </div>
                                                }
                                            <div>
                                                {set_icon(branch_employees.employee_image_name, branch_employees.user_image_name)}          
                                            </div>
                                            <div className="space-betw-vertical" style={{ margin: "0px 10px" }}>
                                                <div> {branch_employees.full_name}</div>
                                                <div>{branch_employees.job_title}</div>
                                            </div>
                                        </div>
                                    </div>
                                } 
                                
                            </div>
                        ))}
                    </div>
                </>
            )}
            {usersAreasMode === "Edit user" && (
                <>
                    <div style={{padding:"0px 6px"}}>
                        <div className="row data_line">
                            <div style={{ display: "flex" }} >
                                <label className="label_area">{pageLables[8].description}</label>
                                <input type="text" className="editing_field" autoComplete="0"
                                    value={employeIndex && branchemployees[employeIndex].full_name} onChange={(e) => setEmployeeDetails({ ...employeeDetails, first_name: e.target.value })} />
                            </div>
                            <div style={{ display: "flex" }} >
                                <label className="label_area">{pageLables[9].description}</label>
                                <input type="text" className="editing_field" autoComplete="0"
                                    value={employeIndex && branchemployees[employeIndex].job_title}/>
                            </div>
                            {systemTypemode && (
                                <>
                                    <div className="data_line" style={{ display: "flex" }} >
                                        <label className="label_area">{pageLables[10].description}</label>
                                        <select id="user_type_cd" className="editing_field">
                                            <option value="0"></option>
                                            {userTypes && userTypes.length >= 0 &&
                                                userTypes.map((user_type, index) => {
                                                    return (
                                                        <option key={index} value={user_type.user_type_cd}>
                                                            {user_type.description}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                </>
                            )}                         
                        </div>
                    </div>
                </>
            )}
            {usersAreasMode === "Edit employee" && (
                <>
                    <div style={{ padding: "0px 6px" }}>
                        <div className="title_area">
                            <label >{pageLables[11].description}</label>
                        </div>
                        {employExist && (
                            <>
                                <div style={{ display: "flex" }} >
                                    <label className="label_area">{pageLables[8].description}</label>
                                    <input type="text" className="editing_field" autoComplete="0"
                                        value={employeIndex && branchemployees[employeIndex].full_name} onChange={(e) => setEmployeeDetails({ ...employeeDetails, first_name: e.target.value })} />
                                </div>
                                <div style={{ display: "flex" }} >
                                    <label className="label_area">{pageLables[9].description}</label>
                                    <input type="text" className="editing_field" autoComplete="0"
                                        value={employeIndex && branchemployees[employeIndex].job_title} />
                                </div>
                            </>
                        )}
                        {!employExist && (
                            <>
                                <div className="data_line" style={{ display: "flex" }} >
                                    <label className="label_area">{pageLables[12].description}</label>
                                    <input type="text" className="editing_field" autoComplete="0"
                                        value={employeeDetails && employeeDetails.first_name} onChange={(e) => setEmployeeDetails({ ...employeeDetails, first_name: e.target.value })} />
                                </div>
                                <div className="data_line" style={{ display: "flex" }} >
                                    <label className="label_area">{pageLables[13].description}</label>
                                    <input type="text" className="editing_field" autoComplete="0"
                                        value={employeeDetails && employeeDetails.middle_name} onChange={(e) => setEmployeeDetails({ ...employeeDetails, middle_name: e.target.value })} />
                                </div>
                                <div className="data_line" style={{ display: "flex" }} >
                                    <label className="label_area">{pageLables[14].description}</label>
                                    <input type="text" className="editing_field" autoComplete="0"
                                        value={employeeDetails && employeeDetails.last_name} onChange={(e) => setEmployeeDetails({ ...employeeDetails, last_name: e.target.value })} />
                                </div>
                                <div className="data_line" style={{ display: "flex" }} >
                                    <label className="label_area">{pageLables[16].description}</label>
                                    <input id="email" type="text" className="editing_field" style={{ outline: "none" }} autoComplete="off"
                                        value={employeeDetails && employeeDetails.email_address} onChange={(e) => setEmployeeDetails({ ...employeeDetails, email_address: e.target.value })} />
                                </div>                      
                                <div className="row data_line">
                                    <div style={{ display: "flex" }} >
                                        <label className="label_area">{pageLables[15].description}</label>
                                        <select className="editing_field" value={employeeDetails && employeeDetails.job_cd} onChange={(e) => setEmployeeDetails({ ...employeeDetails, job_cd: e.target.value })}>
                                            <option value="0"></option>
                                            {jobTitles && jobTitles.length >= 0 &&
                                                jobTitles.map((job_titel, index) => {
                                                    return (
                                                        <option key={index} value={job_titel.code}>
                                                            {job_titel.description}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}
                        {systemTypemode && (
                            <>
                                <div className="data_line" style={{ display: "flex" }} >
                                    <label className="label_area">{pageLables[10].description}</label>
                                    <select className="editing_field" value={employeeDetails && employeeDetails.user_type_cd} onChange={(e) => setEmployeeDetails({ ...employeeDetails, user_type_cd: e.target.value })}>
                                        <option value="0"></option>
                                        {userTypes && userTypes.length >= 0 &&
                                            userTypes.map((user_type, index) => {
                                                return (
                                                    <option key={index} value={user_type.user_type_cd}>
                                                        {user_type.description}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                </div>
                            </>
                        )}
                        <div>
                            <div className="title_area" style={{ marginTop: "20px" }}>
                                <label>{pageLables[17].description}</label>
                            </div>
                            <div className="data_line" style={{ display: "flex" }} >
                                <label className="label_area">{pageLables[18].description}</label>
                                <input type="text" className="editing_field" style={{ outline: "none" }} autoComplete="off"
                                    value={employeeDetails && employeeDetails.login_name} onChange={(e) => setEmployeeDetails({ ...employeeDetails, login_name: e.target.value })} />
                            </div>
                            <div className="data_line" style={{ display: "flex" }} >
                                <label className="label_area">{pageLables[19].description}</label>
                                <input type="text" className="editing_field" style={{ outline: "none" }} autoComplete="off"
                                    value={employeeDetails && employeeDetails.passowrd_id} onChange={(e) => setEmployeeDetails({ ...employeeDetails, passowrd_id: e.target.value })} />
                            </div>
                            <div className="data_line" style={{ display: "flex" }} >
                                <label className="label_area">{pageLables[20].description}</label>
                                <input type="text" className="editing_field" style={{ outline: "none" }} autoComplete="off"
                                    value={employeeDetails && employeeDetails.confirm_password_id} onChange={(e) => setEmployeeDetails({ ...employeeDetails, confirm_password_id: e.target.value })} />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>       
    </>
}

export default Users